module.exports = __webpack_public_path__ + "img/nyc-el.d221a8be.jpg";